import { useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import { OrderDetailDialog } from "./order-detail-dialog";
import { NeftRtgsDialog } from "./neft-rtgs-dialog";

export function Dialogs() {
  const search = useSearch({
    from: Route.id,
  });

  if (search.modal === "order-detail") {
    return <OrderDetailDialog />;
  }

  if (search.modal === "neft-rtgs") {
    return <NeftRtgsDialog />;
  }

  return null;
}
